import { render, staticRenderFns } from "./MonthsEstablishmentSettingForm.vue?vue&type=template&id=7488124e&scoped=true&"
import script from "./MonthsEstablishmentSettingForm.vue?vue&type=script&lang=js&"
export * from "./MonthsEstablishmentSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7488124e",
  null
  
)

export default component.exports